import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Ant Design 样式
import 'antd/dist/reset.css';

// 全站中文化（2026-10-19 用户指令"按钮、提示一律中文"）：
// ① antd 组件文案（分页/弹窗/日期控件/空状态等）走 ConfigProvider zh_CN；
// ② 日期库 dayjs 的星期与月份文本走全局 zh-cn（否则日历面板仍是 Su/Mo… Oct）
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import dayjs from 'dayjs';
// 双保险（2026-10-19）：① 注册式 import（antd 官方标准写法）；② 导入对象显式传参（防打包器摇树）
import 'dayjs/locale/zh-cn';
import dayjsLocaleZh from 'dayjs/locale/zh-cn';
// moment 全局中文化（2026-10-31）：部分面板仍用 moment（三伏贴/Sidebar 的 dddd 星期等），
// 默认英文 locale 曾致"2026-07-18（Wednesday）"式英文漏出；与 dayjs 同口径双保险。
import moment from 'moment';
import 'moment/locale/zh-cn';

dayjs.locale(dayjsLocaleZh);
moment.locale('zh-cn');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ConfigProvider locale={zhCN}>
      <App />
    </ConfigProvider>
  </React.StrictMode>
);

// 如果你想开始测量应用的性能，传递一个函数
// 来记录结果 (例如: reportWebVitals(console.log))
// 或发送到分析端点。了解更多: https://bit.ly/CRA-vitals
reportWebVitals();